var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOverlays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.32 197.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.32,197.45h-148V148.26H0V0H148V49.13h49.35ZM12.4,12.35V135.53H49.33V49.16h86.14V12.35ZM61.82,148.09V185H185V61.82H148v86.27Zm64.55-86.42c-5.32,0-10.56-.05-15.79.06a4.14,4.14,0,0,0-2.5,1.25Q85.46,85.49,62.92,108.12c-.51.5-1.19,1.17-1.2,1.77-.1,5.52-.06,11-.06,16.5Zm9.29,9.73L71.37,135.7c5.12,0,10.5,0,15.87,0a3.19,3.19,0,0,0,1.83-1.06q22.77-22.72,45.49-45.5a3.18,3.18,0,0,0,1.06-1.84C135.7,81.89,135.66,76.52,135.66,71.4ZM91.15,61.68c-5.21,0-10.5,0-15.8,0a3.12,3.12,0,0,0-1.88.93c-3.68,3.6-7.31,7.25-10.93,10.91A2.49,2.49,0,0,0,61.7,75c-.06,5.44,0,10.88,0,16.18Zm14.53,74h29.79v-30C125.34,115.83,115.81,125.58,105.68,135.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOverlays);
export default __webpack_public_path__ + "static/media/edit-overlays.8febfeae5ff810b683a263ee30d5b305.svg";
export { ForwardRef as ReactComponent };